'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$() {
  this.Jz = null;
  $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ = this;
  this.Jz = $j_java$002elang$002e$002dObject.$constArrUVals_I(10, "]g3aOe9Hm31E]N@B]9A5D]2O;H8]MIEB@]");
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ };
$p = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$.prototype = $p;
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$, "java.time.format.internal.TTBPDateTimeFormatterBuilder$NumberPrinterParser$", ({
  lA: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ };
var $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$;
function $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$)) {
    $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ = new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$;
}
export { $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ as $m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser$ };
